export const checkIsMiniApp = () => {
    const urlParams = new URLSearchParams(window.location.search);
    window.isMiniApp = urlParams.get("isMiniApp") === "1";
}

export const isMiniApp = () => {
    return window.isMiniApp || false;
}

export const getLiffId = () => {
    if (process.env.REACT_APP_ONLY_SUPPORT_MINI_APP === "true") {
        return process.env.REACT_APP_MINI_APP_LIFF_ID;
    }
    return (window.isMiniApp || false) ? process.env.REACT_APP_MINI_APP_LIFF_ID : process.env.REACT_APP_LIFF_ID;
}

export const getLiffUrl = () => {
    const liffId = getLiffId();
    if (process.env.REACT_APP_ONLY_SUPPORT_MINI_APP === "true") {
        return `https://miniapp.line.me/${liffId}`;
    }
    return (window.isMiniApp || false) ? `https://miniapp.line.me/${liffId}` : `https://liff.line.me/${liffId}`;
}

